import cookies from 'js-cookie';

function createCookieStorage() {
  return {
    setItem: cookies.set,
    getItem: cookies.get,
    removeItem: cookies.remove,
  };
}

function canUseLocalStorage() {
  try {
    window.localStorage.setItem('_t', 1);
    window.localStorage.removeItem('_t');
    return true;
  } catch (error) {
    return false;
  }
}

export default canUseLocalStorage() ? window.localStorage : createCookieStorage();
